export default "__VITE_ASSET__1fa60cc8__"